/* VÆLD — scroll reveal.
   Elements with [data-reveal] or [data-words-reveal] get an .is-revealed
   class added when they enter the viewport. The actual animation lives
   in CSS — this script only flips the class. */

(function () {
  'use strict';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.querySelectorAll('[data-reveal], [data-words-reveal]').forEach(function (el) {
      el.classList.add('is-revealed');
    });
    return;
  }

  if (!('IntersectionObserver' in window)) {
    document.querySelectorAll('[data-reveal], [data-words-reveal]').forEach(function (el) {
      el.classList.add('is-revealed');
    });
    return;
  }

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-revealed');
        observer.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.15,
    rootMargin: '0px 0px -8% 0px'
  });

  function observeAll() {
    document.querySelectorAll('[data-reveal]:not(.is-revealed), [data-words-reveal]:not(.is-revealed)').forEach(function (el) {
      observer.observe(el);
    });
  }

  observeAll();

  // Re-observe when Shopify theme editor adds/updates sections
  document.addEventListener('shopify:section:load', observeAll);
})();
